// extracted by mini-css-extract-plugin
export default {"linksContainer":"DefaultPage_linksContainer__cxnJy","linksIn":"DefaultPage_linksIn__3lECV","item":"DefaultPage_item__hemgY","icon":"DefaultPage_icon__-8e3m"};